export default __webpack_public_path__ + "2f7dcecbecce71d07594a26f7f8032c4.png";